import React, { createContext, useState, useContext } from "react";
import { Consult } from "../models";

type ConsultContextType = {
	consults: Consult[];
	setConsults: (value: Consult[]) => void;
	refreshConsults: boolean;
	setRefreshConsults: (value: boolean) => void;
	completedConsultsCount: number;
	setCompletedConsultsCount: (value: number) => void;
};

type ConsultContextProviderProps = {
	children: React.ReactNode;
};

const ConsultContext = createContext<ConsultContextType | undefined>(undefined);

export const ConsultProvider = ({ children }: ConsultContextProviderProps) => {
	const [consults, setConsults] = useState<Consult[]>([]);
	const [refreshConsults, setRefreshConsults] = useState(false);
	const [completedConsultsCount, setCompletedConsultsCount] = useState(0);

	return (
		<ConsultContext.Provider
			value={{
				consults,
				setConsults,
				refreshConsults,
				setRefreshConsults,
				completedConsultsCount,
				setCompletedConsultsCount,
			}}
		>
			{children}
		</ConsultContext.Provider>
	);
};

export const useConsultContext = () => {
	const context = useContext(ConsultContext);
	if (context === undefined) {
		throw new Error("useConsultContext must be used within a ConsultProvider");
	}
	return context;
};
